import { useMapContext } from '@components/map/MapContext';
import { createSensorLayerErrorToast } from '@components/ui/toaster/toaster';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectAutomatonCabinetSectionIconFeatures } from '@redux/situation/monitoring.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { ErrorBoundary } from 'react-error-boundary';
import { Layer, Source } from 'react-map-gl/mapbox';

import { MapIdEnum, SourceNameEnum } from '@/types/map.types';

import {
  automatonSectionIconLabelLayer,
  automatonSectionIconLayer,
  perimeterPortalLayer,
} from './automatonSection.layer';

function AutomatonSectionIconLayerContent() {
  const { viewState } = useMapContext();
  const segmentIconFeatures = useSelectorWithReplayMode(selectAutomatonCabinetSectionIconFeatures, viewState.zoom);

  if (!isFeatureCollection(segmentIconFeatures)) return null;

  return (
    <Source id={SourceNameEnum.AUTOMATON_SECTION_ICONS} type="geojson" data={segmentIconFeatures}>
      <Layer {...automatonSectionIconLabelLayer} />
      <Layer {...automatonSectionIconLayer} />
      <Layer {...perimeterPortalLayer} />
    </Source>
  );
}

export default function AutomatonSectionIconLayer() {
  const { mapId } = useMapContext();
  return mapId === MapIdEnum.REPLAY ? (
    <ErrorBoundary fallback={<></>} onError={() => createSensorLayerErrorToast(SourceNameEnum.AUTOMATON_SECTION_ICONS)}>
      <AutomatonSectionIconLayerContent />
    </ErrorBoundary>
  ) : (
    <AutomatonSectionIconLayerContent />
  );
}
